import request from '../util/axios/kakao';

export function getCoordinate (params) {
    return request({
      url: '/v2/local/search/address.json'
      , method: 'get'
      , headers: { Authorization: 'KakaoAK 16e4adbc52b94084ea2de4c3819856b6'}
      , params
    })
  }

  export function getPlaceSearch (params) {
    return request({
      url: '/v2/local/search/keyword.json'
      , method: 'get'
      , headers: { Authorization: 'KakaoAK 16e4adbc52b94084ea2de4c3819856b6'}
      , params
    })
  }
